import React from "react";

export interface Option {
  label: string;
  value: string;
}

export interface ApprovalFilterState {
  start?: string;
  end?: string;
  unit?: string;
  type?: string;
  status?: string;
}

interface Props {
  state: ApprovalFilterState;
  onChange: (s: ApprovalFilterState) => void;
  unitOptions: Option[];
  typeOptions: Option[];
}

const ApprovalFilterBar: React.FC<Props> = ({ state, onChange, unitOptions, typeOptions }) => {
  const update = (k: keyof ApprovalFilterState, v: string) => {
    onChange({ ...state, [k]: v });
  };

  return (
    <div className="mb-4 flex flex-wrap gap-2 items-end">
      <div className="flex flex-col w-40">
        <label className="text-xs font-medium mb-1">From</label>
        <input type="date" className="border px-2 py-2 rounded" value={state.start || ""} onChange={e => update("start", e.target.value)} />
      </div>
      <div className="flex flex-col w-40">
        <label className="text-xs font-medium mb-1">To</label>
        <input type="date" className="border px-2 py-2 rounded" value={state.end || ""} onChange={e => update("end", e.target.value)} />
      </div>
      <div className="flex flex-col w-40">
        <label className="text-xs font-medium mb-1">Unit</label>
        <select className="border px-2 py-2 rounded" value={state.unit || ""} onChange={e => update("unit", e.target.value)}>
          <option value="">All</option>
          {unitOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div className="flex flex-col w-40">
        <label className="text-xs font-medium mb-1">Type</label>
        <select className="border px-2 py-2 rounded" value={state.type || ""} onChange={e => update("type", e.target.value)}>
          <option value="">All</option>
          {typeOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div className="flex flex-col w-40">
        <label className="text-xs font-medium mb-1">Status</label>
        <select className="border px-2 py-2 rounded" value={state.status || ""} onChange={e => update("status", e.target.value)}>
          <option value="">Pending & Rejected</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>
    </div>
  );
};

export default ApprovalFilterBar;
